export default __webpack_public_path__ + "static/media/R_Rugs.0fde8af9.jpg";